<template>

  <div class="print-imei-barcode">
     <KTCodePreview v-bind:title="'In mã sản phẩm'"
      > <template v-slot:toolbar
        > <b-button
          size="sm"
          variant="primary"
          style="width: max-content"
          @click="printData()"
          > <i class="fas fa-print"></i> In mã sản phẩm </b-button
        > </template
      > <template v-slot:preview
        > <b-row class="mb-4"
          > <b-col md="2"
            > <label>Bạn cần in:</label> <b-form-select
              class="select-style"
              v-model="selectLimitPrint"
              :options="listTypePrint"
              size="sm"
              value-field="limit"
              text-field="name"
            ></b-form-select
            > </b-col
          > </b-row
        > <b-table
          bordered
          hover
          :fields="fields"
          :items="listProduct"
          v-if="renderComponent"
          > <template v-slot:head(selected)
            > <span
              > <b-form-checkbox
                v-model="checkAll"
                size="lg"
                @change="checkAllProduct"
              ></b-form-checkbox
              > </span
            > </template
          > <template v-slot:cell(batchCode)="row"
            > <span>{{ row.item.batchCode || row.item.imeiCode }}</span
            > </template
          > <template v-slot:cell(selected)="row"
            >
            <div class="d-flex justify-content-center">
               <b-form-checkbox
                v-model="row.item.selected"
                @change="clickIndex"
              ></b-form-checkbox
              >
            </div>
             </template
          > <template v-slot:cell(productName)="row"
            > <ProductCommonInfo :product="row.item" /> </template
          > <template v-slot:cell(quantity)="row"
            > <b-input
              type="text"
              size="sm"
              class="input-style text-right"
              v-model="row.item.quantity"
              @change="forceRerender"
            ></b-input
            > </template
          > </b-table
        >
        <hr
          class="hr-text"
          data-content="Xem trước"
          style="font-weight: 600"
        />

        <div id="printMe" :style="barcodePreviewStyle">

          <div
            class="imei-print-page"
            v-for="(groupItem, index) in printItems"
            :key="index"
          >

            <div
              class="imei-label"
              v-for="(productItem, count) in groupItem"
              :key="count"
            >

              <div class="imei-label-inner">

                <p class="imei-label-text imei-product-code">
                   {{ productItem.batchCode || productItem.imeiCode || productItem.productCode }}
                </p>

                <div class="imei-barcode-graphic-wrap">
                   <barcode
                    :margin="0"
                    :key="`${productItem.batchCode || productItem.imeiCode || productItem.productCode}-${barCodeHeight}-${selectLimitPrint}`"
                    v-bind:value="
                      productItem.batchCode || productItem.imeiCode || productItem.productCode
                    "
                    format="CODE128"
                    :width="getBarModuleWidth(
                      productItem.batchCode || productItem.imeiCode || productItem.productCode
                    )"
                    :height="barCodeHeight"
                    :fontSize="getBarcodeFontSize"
                    :displayValue="false"
                    :marginTop="0"
                    :marginLeft="0"
                    :marginRight="0"
                    :marginBottom="0"
                    :textMargin="0"
                  />
                </div>

                <p
                  class="imei-label-text imei-label-price"
                  v-if="!productItem.imeiCode"
                >
                   Giá: <span class="imei-label-price-value">{{ formatLabelPrice(productItem.sellingPrice) }}</span>
                </p>

                <p
                  :class="[
                    'imei-label-text',
                    'imei-label-name',
                    'mt-0',
                    { 'imei-label-name-long': (productItem.productName || '').length > 40 },
                  ]"
                >
                   {{ productItem.productName }}
                </p>

              </div>

            </div>

          </div>

        </div>
         </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import { convertPrice } from '@/utils/common'
  import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue'
  import VueBarcode from 'vue-barcode'
  import ApiService from '@/core/services/api.service'
  import { handleError } from '@/utils/common'

  export default {
    props: ['data'],
    data() {
      return {
        listProduct: [],
        selectLimitPrint: 1,
        listTypePrint: [
          {
            limit: 1,
            name: 'Khổ 1 tem (40×20mm)',
          },
          {
            limit: 2,
            name: 'Khổ 2 tem (80×20mm)',
          },
          {
            limit: 3,
            name: 'Khổ 3 tem (120×20mm)',
          },
        ],
        renderComponent: true,
        fields: [
          {
            key: 'batchCode',
            label: 'Mã vạch/ IMEI',
            thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
            tdClass: 'text-left',
          },
          {
            key: 'productName',
            label: 'Sản phẩm',
            thStyle: { fontWeight: 600, color: '#181c32', width: '40%' },
            tdClass: 'text-left',
          },
          {
            key: 'sellingPrice',
            label: 'Giá bán',
            thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
            tdClass: 'text-right',
            formatter: (value) => {
              return convertPrice(value)
            },
          },
          {
            key: 'quantity',
            label: 'SL',
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
            tdClass: 'text-right',
          },
          { key: 'selected', label: '', tdClass: 'text-center' },
        ],
        checkAll: true,
      }
    },
    created() {
      const stockSlipId = this.$route.query.stockSlipId
      if (stockSlipId) {
        this.fetchDataByStockSlip(stockSlipId)
      } else {
        const listItem = this.data.listItem ? this.data.listItem : []
        this.genData(listItem)
      }
    },
    computed: {
      getWidthBarCode() {
        return 1.76
      },
      getBarcodeFontSize() {
        switch (this.selectLimitPrint) {
          case 1:
            return 7
          case 2:
            return 6
          case 3:
            return 6
          default:
            return 7
        }
      },
      /** Chiều cao vạch barcode (px) — cố định, label luôn là 40×20mm. */
      barCodeHeight() {
        return 40
      },
      barCodeHeightMm() {
        return (this.barCodeHeight / 3.7795275591).toFixed(2)
      },
      barCodePrintHeight() {
        // Preview label: 280px rộng × tỉ lệ 40/20 = 140px cao.
        // Print label: 20mm = 75.59px. Scale = 75.59 / 140 ≈ 0.54 để giữ tỉ lệ giống preview.
        const scale = (20 * 3.7795275591) / 140
        return Math.round(this.barCodeHeight * scale)
      },
      barCodePrintHeightMm() {
        return (this.barCodePrintHeight / 3.7795275591).toFixed(2)
      },
      barcodePreviewStyle() {
        return {
          '--barcode-height-px': `${this.barCodeHeight}px`,
          '--barcode-height-mm': `${this.barCodeHeightMm}mm`,
        }
      },
      printItems() {
        const seletedItems = this.listProduct.filter((product) => product.selected)
        if (!seletedItems.length) {
          return []
        }
        const listProductPrint = []
        seletedItems.forEach((seletedItem) => {
          const quantity = parseInt(seletedItem.quantity)
          for (let index = 0; index < quantity; index++) {
            listProductPrint.push({ ...seletedItem })
          }
        })
        const numPage = Math.ceil(listProductPrint.length / this.selectLimitPrint)
        const items = []
        for (let page = 1; page <= numPage; page++) {
          const startIndex = this.selectLimitPrint * (page - 1)
          const endIndex = page * this.selectLimitPrint
          const groupItem = listProductPrint.slice(startIndex, endIndex)
          items.push(groupItem)
        }
        return items
      },
    },
    watch: {
      // Safety net cho async load (stockSlipId): updated() có thể fire
      // trước khi vue-barcode render xong SVG, watch đảm bảo fix chạy đúng lúc.
      printItems() {
        this.fixSvgViewBox()
      },
    },
    methods: {
      /** Cùng định dạng số với trang In mã vạch (Sản phẩm > In sản phẩm). */
      formatLabelPrice(number) {
        if (number === null || number === undefined) {
          return new Intl.NumberFormat('vn-VN').format(0)
        }
        return new Intl.NumberFormat('vn-VN').format(number)
      },
      async fetchDataByStockSlip(stockSlipId) {
        try {
          const response = await ApiService.get(
            `v1/product-search/get-batch-code-by-stock-slip/${stockSlipId}`,
          )
          this.listProduct = response.data.data.map((data) => {
            return {
              ...data,
              selected: true,
              imeiCode: data.productImei,
            }
          })
        } catch (err) {
          handleError(err)
        }
      },
      convertPrice,
      forceRerender() {
        this.renderComponent = false

        this.$nextTick(() => {
          this.renderComponent = true
        })
      },
      /** Chiều rộng trang in (mm) = số tem × 40mm */
      getTemWidth: function () {
        return 40 * this.selectLimitPrint
      },
      getLabelHeightMm: function () {
        return 20
      },
      /** Thu hẹp độ rộng vạch để mã dài vẫn vừa tem, không cần scale SVG theo width. */
      getBarModuleWidth(code) {
        if (!code) return 1.6;
        const str = String(code);
        // CODE128: mỗi ký tự ~11 modules, thêm start/stop ~35 modules
        const totalModules = str.length * 11 + 35;
        // Target width = 38mm = 143.6px (tại 96dpi)
        const targetPx = 143.6;
        const moduleWidth = targetPx / totalModules;
        // Clamp: min 0.8, max 2.2
        return Math.min(2.2, Math.max(0.8, parseFloat(moduleWidth.toFixed(2))));
      },
    /** Chuẩn hóa SVG trước khi in để chiều cao khớp preview. */
      normalizePrintBarcodes(rootEl) {
        const barHMm = this.barCodePrintHeightMm;
        rootEl.querySelectorAll('.imei-barcode-graphic-wrap svg').forEach((svg) => {
          const w = parseFloat(svg.getAttribute('width') || svg.clientWidth || 200);
          const h = parseFloat(svg.getAttribute('height') || svg.clientHeight || 40);

          // Set viewBox nếu chưa có
          if (!svg.getAttribute('viewBox') && w && h) {
            svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
          }
          // Luôn set preserveAspectRatio none để stretch full width khi in
          svg.setAttribute('preserveAspectRatio', 'none');

          // Override size
          svg.setAttribute('width', '100%');
          svg.setAttribute('height', String(Math.round(parseFloat(barHMm) * 3.7795)));
          svg.style.setProperty('width', '100%', 'important');
          svg.style.setProperty('max-width', '100%', 'important');
          svg.style.setProperty('height', `${barHMm}mm`, 'important');
          svg.style.setProperty('display', 'block', 'important');
        });
      },
      fixSvgViewBox() {
        this.$nextTick(() => {
          this._applySvgFix(document)
        })
      },
      _applySvgFix(rootEl) {
        rootEl.querySelectorAll('.imei-barcode-graphic-wrap svg').forEach((svg) => {
          // Đã xử lý rồi → bỏ qua.
          // Quan trọng: nếu gọi lại sau khi width='100%' đã set,
          // parseFloat('100%')=100 sẽ tạo viewBox sai → barcode bị cắt.
          if (svg.dataset.vbFixed) return

          const w = parseFloat(svg.getAttribute('width') || svg.getBoundingClientRect().width || 200)
          const h = parseFloat(svg.getAttribute('height') || svg.getBoundingClientRect().height || 40)

          if (w > 0 && h > 0) {
            svg.setAttribute('viewBox', `0 0 ${w} ${h}`)
          }
          svg.setAttribute('preserveAspectRatio', 'none')
          svg.setAttribute('width', '100%')
          svg.removeAttribute('height')
          svg.style.cssText += ';width:100%!important;display:block!important;'
          svg.dataset.vbFixed = '1'
        })
      },
      printData: function () {
        const printMe = document.getElementById('printMe')
        if (!printMe) {
          return
        }

        const clone = printMe.cloneNode(true)
        this.normalizePrintBarcodes(clone)
        const prtHtml = clone.innerHTML

        const width = this.getTemWidth()
        const labelH = this.getLabelHeightMm()
        const barHMm = this.barCodePrintHeightMm

        // Open the print window
        const WinPrint = window.open(
          '',
          '',
          'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0',
        )

        WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          <style>
          html, body {
            margin: 0;
            padding: 0;
            font-family: Tahoma, Verdana, sans-serif;
          }
          @page {
            size: ${width}mm ${labelH}mm;
            margin: 0;
            }
          @media print {
            html,
            body {
              width: ${width}mm;
              height: auto !important;
              margin: 0 !important;
              padding: 0 !important;
              display: block !important;
              line-height: 1.1 !important;
              box-sizing: border-box;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
          .imei-print-page {
            display: flex;
            flex-direction: row;
            align-items: stretch;
            justify-content: flex-start;
            width: ${width}mm;
            height: ${labelH}mm;
            min-height: ${labelH}mm;
            max-height: ${labelH}mm;
            box-sizing: border-box;
            page-break-inside: avoid;
            overflow: hidden;
          }
          .imei-print-page:not(:last-child) {
            page-break-after: always;
            break-after: page;
          }
          .imei-label {
            flex: 0 0 auto;
            width: 40mm !important;
            height: ${labelH}mm !important;
            min-width: 40mm !important;
            max-width: 40mm !important;
            min-height: ${labelH}mm !important;
            max-height: ${labelH}mm !important;
            margin: 0 !important;
            box-sizing: border-box;
            display: flex !important;
            flex-direction: column;
            align-items: stretch;
            justify-content: flex-start;
            overflow: hidden;
            visibility: visible !important;
            opacity: 1 !important;
            background: #ffffff !important;
          }
          .imei-label-inner {
            flex: 1 1 auto;
            width: 100% !important;
            height: 100%;
            min-height: 0;
            box-sizing: border-box;
            padding: 1mm 2mm 0 1.5mm;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
            overflow: hidden;
            visibility: visible !important;
            opacity: 1 !important;
            background: #ffffff !important;
          }
          .imei-label-text {
            color: #000 !important;
            font-weight: 400;
            text-align: center;
            margin: 0;
            padding: 0 1mm;
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            word-wrap: break-word;
            overflow-wrap: anywhere;
            flex-shrink: 1;
            min-height: 0;
            visibility: visible !important;
            opacity: 1 !important;
          }
          .imei-product-code {
            font-size: 8.5px !important;
            line-height: 1 !important;
            font-weight: 500;
            letter-spacing: 0 !important;
            margin: 0 0 0.5mm 0 !important;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex-shrink: 0;
          }
          .imei-label-price {
            font-size: 8.5px !important;
            margin-top: 0.5mm !important;
            font-weight: 400;
            margin-top: 0;
            flex-shrink: 0;
          }
          .imei-label-price-value {
            font-weight: 700 !important;
          }
          .imei-label-name {
            font-size: 8.5px !important;
            line-height: 1.3 !important;
            font-weight: 400;
            margin-top: 0.5mm !important;
            margin-bottom: 0 !important;
            max-height: 3.9em;
            display: -webkit-box;
            line-clamp: 3;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .imei-label-name-long {
            font-size: 8.5px !important;
            line-height: 1.1 !important;
            max-height: 3.6em;
            line-clamp: 3;
            -webkit-line-clamp: 3;
          }
          .imei-barcode-graphic-wrap {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            text-align: center;
            line-height: 0;
            overflow: hidden;
          }
          .imei-barcode-graphic-wrap .vue-barcode-element {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            margin: 0 auto !important;
            line-height: 0 !important;
            visibility: visible !important;
            opacity: 1 !important;
          }
          .imei-barcode-graphic-wrap svg {
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            height: ${barHMm}mm !important;
            min-height: ${barHMm}mm !important;
            max-height: ${barHMm}mm !important;
            margin: 0 !important;
            overflow: visible;
            visibility: visible !important;
            opacity: 1 !important;
          }
          @media print {
            .imei-barcode-graphic-wrap svg {
              width: auto !important;
              max-width: 100% !important;
              height: ${barHMm}mm !important;
              min-height: ${barHMm}mm !important;
              max-height: ${barHMm}mm !important;
            }
          }
          </style>
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`)

        WinPrint.document.close()
        const triggerPrint = () => {
          WinPrint.focus()
          WinPrint.print()
        }
        if (WinPrint.document.readyState === 'complete') {
          triggerPrint()
        } else {
          WinPrint.onload = triggerPrint
        }
      },
      checkAllProduct() {
        this.listProduct.forEach((product) => {
          product.selected = this.checkAll
        })
      },
      clickIndex() {
        if (this.checkAll === true) {
          this.checkAll = false
        } else {
          const selectedItems = this.listProduct.filter((product) => product.selected)
          this.checkAll = selectedItems.length === this.listProduct.length
        }
      },
      genData(data) {
        this.listProduct = data.map((data) => {
          return {
            ...data,
            selected: true,
          }
        })
      },
    },
    components: {
      KTCodePreview,
      barcode: VueBarcode,
      ProductCommonInfo,
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'IMEI', route: '/imeis' },
        { title: 'In mã sản phẩm', route: '/imeis/print-imei-barcode' },
      ])
      this.fixSvgViewBox()
    },
    updated() {
      this.fixSvgViewBox()
    },
  }
</script>

<style scoped>
  .header-print {
  text-align: center;
  width: 100%;
}
.imei-label {
  width: min(280px, 100%) !important;
  max-width: 100%;
  aspect-ratio: 40 / 20;
  box-sizing: border-box;
  display: flex !important;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #eceff3;
  font-family: Tahoma, Verdana, sans-serif;
}
.imei-label-inner {
  flex: 1 1 auto;
  width: 100% !important;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 4px 8px 0 8px;
  text-align: center;
  overflow: hidden;
  background: #ffffff;
}
.imei-label-text {
  color: black;
  font-weight: 400;
  text-align: center;
  margin: 0;
  padding: 0 4px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}
.imei-product-code {
  font-size: 16px;
  line-height: 1;
  font-weight: 500;
  letter-spacing: 0;
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
}
.imei-label-price {
  font-size: 16px;
  line-height: 1.1;
  font-weight: 400;
  margin: 2px 0 0;
  flex-shrink: 0;
}
.imei-label-price-value {
  font-weight: 700;
}
.imei-label-name {
  font-size: 16px;
  line-height: 1.3;
  font-weight: 400;
  margin-top: 2px;
  margin-bottom: 0;
  max-height: 3.9em;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.imei-label-name-long {
  font-size: 16px;
  line-height: 1.2;
  max-height: 3.6em;
  line-clamp: 3;
  -webkit-line-clamp: 3;
}
.imei-barcode-graphic-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  text-align: center;
  line-height: 0;
  overflow: hidden;
}
.imei-print-page {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 8px;
  margin-bottom: 1rem;
}
.imei-print-page .imei-label {
  flex: 0 0 auto;
  margin-bottom: 0;
}
</style>

<style lang="scss">
  .print-imei-barcode {
  #printMe {
    overflow-x: visible;
  }
/* ── Barcode wrap: block (không dùng flex để tránh shrink SVG) ── */
  .imei-barcode-graphic-wrap {
    display: block;
    width: 100%;
    max-width: 100%;
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    line-height: 0;
    overflow: hidden;
  }

  /* vue-barcode wrapper: block, full width */
  .imei-barcode-graphic-wrap .vue-barcode-element {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    line-height: 0 !important;
  }

  /*
   * SVG: width 100% để stretch full container.
   * height được kiểm soát bởi CSS variable --barcode-height-px.
   * preserveAspectRatio="none" được set bởi fixSvgViewBox() → stretch không méo code,
   * chỉ phần whitespace margin của vue-barcode bị compress.
   */
  .imei-barcode-graphic-wrap svg {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    height: var(--barcode-height-px, 40px) !important;
    min-height: var(--barcode-height-px, 40px) !important;
    max-height: var(--barcode-height-px, 40px) !important;
    margin: 0 !important;
    overflow: visible;
  }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }
  .table.b-table.table-sm
    > thead
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left),
  .table.b-table.table-sm
    > tfoot
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left) {
    background-position: right calc(1.5rem / 2) center;
    padding-right: calc(0.3rem + 0.65em);
  }
  /* custom scrollbar */
  ::-webkit-scrollbar {
    width: 13px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 3px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #a8bbbf;
  }
}
</style>

